export class Member {
  member_id: number;
  sdp_member_id: number;
  member_type: string;
  first_name: string;
  last_name: string;
  gender: string;
  birth_day: number;
  birth_month: number;
  birth_year: number;

  nationality: string;
  education: number;
  occupation: number;

  race: number;

  marital_status: number;
  reg_member_age: number;
  spoken_language: number;

  employment_status: number;

  preferred_language: number;
  missingDataFlag: boolean;

  participation: {
    panel_optout: string;
    panel_optin_date: string;
    panel_optout_date: string;
  };

  work_industry: number;
  work_department: number;
  company_size: number;
  work_purchase_influence: number;
  work_purchase_influence_details: number;
  check_page: boolean;

  constructor(obj?: any) {
    if (obj) {
      this.member_id = obj.member_id;
      this.sdp_member_id = obj.sdp_member_id;
      this.first_name = obj.first_name;
      this.last_name = obj.last_name;
      this.gender = obj.gender;
      this.birth_day = obj.birth_day;
      this.birth_month = obj.birth_month;
      this.birth_year = obj.birth_year;
      this.member_type = obj.member_type;
      this.nationality = obj.nationality;

      this.race = obj.race;

      this.marital_status = obj.marital_status;
      this.reg_member_age = obj.reg_member_age;
      this.spoken_language = obj.spoken_language;

      this.employment_status = obj.employment_status;

      this.preferred_language = obj.preferred_language;

      this.education = obj.education;
      this.occupation = obj.occupation;
      this.participation = obj.participation;

      this.work_industry = obj.work_industry;
      this.work_department = obj.work_department;
      this.company_size = obj.company_size;
      this.work_purchase_influence = obj.work_purchase_influence;

      this.work_purchase_influence_details =
        obj.work_purchase_influence_details;
      this.missingDataFlag = obj.missingDataFlag ? obj.missingDataFlag : false;
      this.check_page = false;
    } else {
      this.member_id = 0;
      this.sdp_member_id = 0;
      this.first_name = 'null';
      this.last_name = 'null';
      this.gender = '';
      this.birth_day = 0;
      this.birth_month = 0;
      this.birth_year = 0;
      this.member_type = 'null';
      this.nationality = '';
      this.education = 0;
      this.occupation = 0;

      this.race = 0;

      this.marital_status = 0;
      this.reg_member_age = 0;
      this.spoken_language = 0;

      this.employment_status = 0;

      this.preferred_language = 0;

      this.participation = {
        panel_optout: 'N',
        panel_optin_date: 'null',
        panel_optout_date: 'null'
      };

      this.work_industry = 0;
      this.work_department = 0;
      this.company_size = 0;
      this.work_purchase_influence = 0;
      this.work_purchase_influence_details = 0;
      this.missingDataFlag = false;
      this.check_page = false;
    }
  }
}
